import { ENotice, ESnapshot, exists } from 'lib/types';

// Mail and possibly other pricing inputs live outside the notice doc; an edit stamp is the only signal they changed.
export function getNoticeContentRevisionMillis(
  noticeSnap: ESnapshot<ENotice> | null | undefined
): number | null {
  if (!exists(noticeSnap)) {
    return null;
  }
  const { editedAt, confirmedAt } = noticeSnap.data();
  return (editedAt || confirmedAt)?.toMillis() ?? null;
}

export function sumFirstI(array: any[], i: any): number {
  return array.reduce(
    (a, b, j) =>
      j <= i
        ? +parseFloat(a).toFixed(2) + +parseFloat(b).toFixed(2)
        : +parseFloat(a).toFixed(2),
    0
  );
}
